import { statusColorMap } from "./CalendarUtils";
import { useCalendar } from "../contexts/CalendarContext";
import { logEvent } from "../utils/analyticsLogger";
import { Box, CircularProgress } from "@mui/material";
import { EventContentArg } from "@fullcalendar/core";
import { ICalendarEvent } from "../types/calendar";
import { StringParam, useQueryParam } from "use-query-params";

// Same hover colour the /documents index links use.
const HOVER_COLOR = "#00b8d4";

interface Props {
  eventInfo: EventContentArg;
  isLoading: boolean;
  view: string;
}

const CalendarEventContent = ({ eventInfo, isLoading, view }: Props) => {
  const { viewMode, setModalOrder } = useCalendar();
  const [orderNumberUrlParam, setOrderNumberUrlParam] = useQueryParam("ordernumber", StringParam);
  const calendarEvent = (eventInfo?.event?.extendedProps || {}) as ICalendarEvent;
  const { status = "default", accountRep = "", funder = "", clientName = "", titleCloser = "" } = calendarEvent;
  const color = statusColorMap[status] || statusColorMap["default"];

  const handleClick = () => {
    logEvent("Closing Calendar", "View Closing", "");
    setOrderNumberUrlParam(calendarEvent.orderNumber);
    setModalOrder(calendarEvent);
  };

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      {/* Box, not a styled span: an inline `style` colour can't be overridden by a
          hover rule, so the hover state has to come from a class. */}
      <Box
        component="span"
        sx={{
          color,
          fontSize: "12px",
          fontWeight: 700,
          cursor: "pointer",
          "&:hover": { color: HOVER_COLOR }
        }}
        onClick={handleClick}
      >
        {" "}
        {eventInfo.event.title}
      </Box>
      {viewMode === "rep" && (
        <span style={{ paddingLeft: "7px", fontSize: "11px" }}>
          {accountRep || "..."} / {funder || "..."}
        </span>
      )}
      {viewMode === "client" && <span style={{ paddingLeft: "7px", fontSize: "11px" }}>{clientName}</span>}
      {viewMode === "titlecloser" && <span style={{ paddingLeft: "7px", fontSize: "11`px" }}>{titleCloser}</span>}
      {!eventInfo.isDraggable && view == "dayGridMonth" && <CircularProgress size="12px" sx={{ marginLeft: "5px" }} />}
    </>
  );
};
export default CalendarEventContent;
